// extracted by mini-css-extract-plugin
export default {"knowHow_container":"know-how_knowHow_container__CyVVf"};